import { check, object, pipe, string, union } from 'valibot'

export class NotFoundError extends Error {
  status = 404

  constructor(message = 'Not Found') {
    super(message)
    this.name = 'NotFoundError'
  }
}

const ignoredScriptSources = [
  'https://js-eu1.hubspot.com',
  'https://js-eu1.hscollectedforms.net',
  'chrome-extension://',
]

const hsScript = pipe(
  string(),
  check(it => !it.includes('csp_violation') && ignoredScriptSources.some(src => it.includes(src))),
)

const error = union([
  object({ stack: hsScript }),
  object({ handling_stack: hsScript }),
])

export const ignoredErrorSchema = union([
  object({ error }),
  object({ attributes: object({ error }) }),
  object({ attributes: error }),
  error,
])
